
<div class="dtf-olp" style="background-color: #E6E6E6;">

    <div class="container_dashboard">
        <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">
          
          <div class="example-button-row">
            <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
              <mat-button-toggle  [value]="toggleEnum.Option7" [class.selected]="selectedState === toggleEnum.Option7">Make a Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option1" [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option3" [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option6" [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option4" [class.selected]="selectedState === toggleEnum.Option4" style="background-color: #00566A !important; color: white !important;">Manage Bank Profile</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option2" [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option8" [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
            </mat-button-toggle-group>
            </div>
        </div> 
      </div>
    <!-- <div *ngIf="!loaded" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
        <div class="demo-container">
            <span class="lightcon">Loading</span>
            <div class="progress-bar">
                <div class="progress-bar-value"></div>
            </div>
        </div>
        <br>
    </div> -->

    <div class="container_dashboard">

            <div class="cardlike">
                <h1>Manage Bank Profile</h1>
                <div class="pageStyle paragrapSpace">
                    To edit or remove an existing bank profile, select the specific bank profile from the dropdown menu and click
                    the Edit Profile button to edit or the Remove Profile button to delete the profile.
                </div>
            </div>

            <br><br>
           <div class="card"  style="width: 97%; margin-left: 20px;">
                <div *ngIf="blocked">
                    <dtf-errorhandling [blocked]="blocked" [errorMessage]="errmsg"></dtf-errorhandling>
                </div>
                <div *ngIf="!blocked">
                    <div class="row">
                        <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                            <div class="pageStyle paragrapSpace">
                                {{manageBankProfileSubText}}
                            </div>
                            <div class="backimage paragrapSpace" style="background-color: #f4f4f4; padding: 5px; border-radius: 5px; padding-left: 10px; padding-bottom: 10px; padding-right: 10px;">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Bank Profile</div>
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ 'onlinepayment.select1' | translate }}<span style="color: red;">*</span></mat-label>
                                            <mat-select [(ngModel)]="selected" (ngModelChange)="onChange()">
                                              <mat-option *ngFor="let opt of dropDownList" [value]="opt.id">
                                                {{opt.selection}}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Bank Name</div>
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 lightcon">{{bankDetailObj.bankName}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Bank Account Type</div>
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 lightcon">
                                        {{bankDetailObj.type}}</div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Bank Account Category</div>
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 lightcon">
                                        {{ this.bankAcctCategory }}</div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Routing Number</div>
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 lightcon">
                                        xxxxx{{bankDetailObj.maskedRoutingNumber | slice:-4}}</div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 title">Email Address</div>
                                    <div class="col-lg-5 col-md-5 col-sm-4 col-xs-6 lightcon">{{bankDetailObj.email}}
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="button-flex">
                                <div><button class="mbfs-button" [routerLink]="['/home/editprofile']">
                                    Edit Profile</button></div>
                                <div><button  class="mbfs-button" value="Remove Profile >"
                                    [routerLink]="['/home/removeprofile']" >Remove Profile</button></div>
                                <div><button  class="mbfs-button" value="Add Profile +"
                                        [routerLink]="['/home/addprofile']" >Add Profile</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br><br>
    </div>
</div>